import $ from 'jquery';
import './jquery-ui.min.js';
import {
  getYoutubeVideoId,
  validateEmail,
  validatePhone,
  request,
  notificationInline,
  notification,
} from './utility';

let dialog;
dialog = $('#dialog-video').dialog({
  dialogClass: 'dialog-video-wrapper',
  height: 'auto',
  width: 'auto',
  position: 'center',
  autoOpen: false,
  modal: true,
  buttons: [
    {
      text: '',
      icon: 'icon-cancel',
      click: function () {
        $(this).dialog('close');
      },
    },
  ],
  close: function () {
    const iframe = document.querySelector('.js-iframe-video');
    iframe.src = '/';
  },
});
$('.js-play-video').on('click', function (event) {
  event.preventDefault();
  const videoLink = event?.currentTarget?.getAttribute('href');
  const videoId = getYoutubeVideoId(videoLink);
  const newLink =
    'https://www.youtube-nocookie.com/embed/' +
    videoId +
    '?si=MBS7RACcFk6csPIO&amp;controls=0';
  const iframe = document.querySelector('.js-iframe-video');
  iframe.src = newLink;
  dialog.dialog('open');
});

$('#tabs-theme-1-9').tabs({
  active: 0,
});

$('.landing-accordion').accordion({
  active: 0,
  header: 'div.header',
  heightStyle: 'content',
  collapsible: true,
  activate: function (event, ui) {
    const activatedPanel = ui.newPanel;
    const parentOfActivatedPanel = $(activatedPanel).parent();
    parentOfActivatedPanel.addClass('active');

    const deactivatedPanel = ui.oldPanel;
    const parentOfDeactivatedPanel = $(deactivatedPanel).parent();
    parentOfDeactivatedPanel.removeClass('active');
  },
});

$('.widget-questions').accordion({
  active: 0,
  collapsible: true,
  header: 'h3',
  heightStyle: 'content',
});

$('button[name="form-contact-course-submit"]').on('click', function (event) {
  event.preventDefault();
  const $form = $(this).closest('form[name="form-contact-course"]');
  $form.find('input').removeClass('error success');
  $form.find('textarea').removeClass('error success');

  const data = $form.serializeArray();
  let isCheck = true;
  data.map(function (item) {
    switch (true) {
      case item.name === 'name' && !item.value:
        $form.find('input[name="' + item.name + '"]').addClass('error');
        isCheck = false;
        break;
      case item.name === 'phone' && !validatePhone(item.value):
        $form.find('input[name="' + item.name + '"]').addClass('error');
        isCheck = false;
        break;
      case item.name === 'email' && item.value && !validateEmail(item.value):
        $form.find('input[name="' + item.name + '"]').addClass('error');
        isCheck = false;
        break;
      case item.name === 'content' && !item.value:
        $form.find('textarea[name="' + item.name + '"]').addClass('error');
        isCheck = false;
        break;
      default:
        break;
    }
  });
  if (isCheck) {
    $form.find('button').attr('disabled', true);
    $.when(request('POST', APP_URL + '/api/contact2', data))
      .done(function (resposive) {
        $form[0].reset();
        if (!resposive?.error) {
          notification(
            'SUCCESS',
            LANG_CODE === 'vn' ? 'Gửi thành công' : 'Submitted successfully',
          );
          notificationInline(
            'SUCCESS',
            LANG_CODE === 'vn' ? 'Gửi thành công' : 'Submitted successfully',
            'noti',
          );
          $form.find('button').attr('disabled', false);
          $.when(
            request('POST', APP_URL + '/api/send-email', {
              subject: resposive?.data?.subject,
              content: resposive?.data?.content,
              emailCustomer: resposive?.data?.emailCustomer,
            }),
          );
        } else {
          notification(
            'ERROR',
            LANG_CODE === 'vn' ? 'Gửi không thành công' : 'Sending failed',
          );
        }
      })
      .fail(function (error) {
        $form[0].reset();
      });
  } else {
    notification(
      'ERROR',
      LANG_CODE === 'vn' ? 'Vui lòng nhập dữ liệu' : 'Please enter data',
    );
  }
});
